import { strapi } from "@strapi/client";
import qs from "qs";
import getErrorMessage from "./get-error";

const cms = strapi({
  baseURL: process.env.NEXT_PUBLIC_API_URL ?? "",
  auth: process.env.NEXT_PUBLIC_API_TOKEN,
});

type Config = RequestInit & {
  [key: string]: any | Config;
};

export const BASE_CONFIG = {
  pLevel: 6,
};

const cacheRebuild = process.env.NEXT_PUBLIC_FORCE_CACHE_REBUILD || "true";

export const getCms = async (
  collection: string,
  locale = "en",
  config: Config = {}
) => {
  const { next, cache, ...queryConfig } = config;

  const query = qs.stringify(
    {
      ...BASE_CONFIG,
      locale: locale,
      ...queryConfig,
    },
    { encodeValuesOnly: true }
  );

  const urlFetch = `${collection}?${query}`;
  if (process.env.NODE_ENV === "development") {
    console.log("Fetching CMS:", urlFetch);
  }

  try {
    const cmsResponse = await cms.fetch(urlFetch, {
      cache: cache,
      next: next,
      method: "GET",
      headers: {
        "x-cache-rebuild": cacheRebuild,
      },
    });
    const { data, meta } = await cmsResponse.json();
    return [data, meta] as const;
  } catch (error) {
    console.error(
      `Error fetching CMS: ${getErrorMessage(error).error} - URL: ${urlFetch}`
    );
    return [undefined, undefined];
  }
};
